module.exports = __webpack_public_path__ + "static/wfcp-53053775f09d5592b2ed64f4e7ab07b3.png";